// Witcore Suite - Version 1.0.0
// Copyright(c) 2024 Witcore LLC. All rights reserved.

import React from 'react';

const StepProgressBar = function ({ value, dataSource, colors, stepsGroups }) {
  return (
    <div className="step-progress-bar">
      {dataSource.map(function (dataSourceItem, index) {
        if (index < (dataSource.length - 1) && stepsGroups && stepsGroups.some(stepGroup => stepGroup[0] === dataSourceItem[0] && stepGroup[1] === dataSource[index + 1][0])) {
          return (
            <div index={'step-' + index} className="step-progress-bar-item">
              <div className={'counter fw-bold ' + (dataSourceItem[0] === value || dataSource[index + 1][0] === value ? ' bg-' + (colors[value] ?? 'blue') : ' bg-gray-lighter')}>{index + 1}</div>
              {dataSourceItem[0] === value || dataSource[index + 1][0] === value ?
                (dataSourceItem[0] === value ? <div className="text">{dataSourceItem[1]}</div> : <div className="text">{dataSource[index + 1][1]}</div>) :
                <div className={dataSourceItem[0] === value || dataSource[index + 1][0] === value ? 'fw-bold' : ''}>{dataSourceItem[1] + ' / ' + dataSource[index + 1][1]}</div>
              }
            </div>
          );
        }
        else if (index > 0 && stepsGroups && stepsGroups.some(stepGroup => stepGroup[0] === dataSource[index - 1][0] && stepGroup[1] === dataSourceItem[0])) {
          return null;
        }
        else {
          return (
            <div index={'step-' + index} className="step-progress-bar-item">
              <div className={'counter fw-bold ' + (dataSourceItem[0] === value ? ' bg-' + (colors && colors[value] ? colors[value] : 'blue') : ' bg-gray-lighter')}>{index + 1}</div>
              <div className={dataSourceItem[0] === value ? 'fw-bold' : ''}>{dataSourceItem[1]}</div>
            </div>
          )
        }
      })}
    </div>
  );
}

export default StepProgressBar;
